import React from 'react';
import { Grid, Stack } from '@mui/material';
import SearchToggleButton from './SearchToggleButton';
import GlobalSearchSelector from './GlobalSearchSelector';

interface GlobalSearchProps {
  // Hides the Member/Task toggle so the search field can take the full width of the
  // component - used on mobile while the search is focused, where there isn't room for both.
  hideToggle?: boolean;
  // Fired when focus enters/leaves the search input specifically (not the Member/Task toggle),
  // so clicking the toggle doesn't itself trigger the mobile expand behavior.
  onSearchFocus?: () => void;
  onSearchBlur?: () => void;
}

const GlobalSearch: React.VFC<GlobalSearchProps> = ({ hideToggle = false, onSearchFocus, onSearchBlur }) => {
  return (
    <Stack style={{ backgroundColor: '#ffffff' }}>
      <Stack direction="row" alignItems="center">
        <Grid sx={{ width: { xs: '100%', sm: 375 }, minWidth: 0 }} onFocus={onSearchFocus} onBlur={onSearchBlur}>
          <GlobalSearchSelector />
        </Grid>
        {!hideToggle && <SearchToggleButton />}
      </Stack>
    </Stack>
  );
};

export default GlobalSearch;
